$(function () {
  const nodeList = document.querySelectorAll('[data-autosubmit]');
  Array.from(nodeList).forEach(element => {
    const el = $(element)

    el.on('change', function() {
      el.closest('form').submit()
    })
  })
});